"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 54.78 24",
    width: "54.78",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m13.52 3.85a.49.49 0 0 0 -.46-.31h-5.52a.5.5 0 0 0 -.54.46v13.92a.45.45 0 0 0 0 .2.49.49 0 0 0 .46.3h5.52a.5.5 0 0 0 .5-.5v-13.92a.38.38 0 0 0 .04-.15zm-.66 7.06a2.5 2.5 0 0 1 -2.5 2.5h-.12a2.5 2.5 0 0 1 -2.5-2.5v-4.24a2.5 2.5 0 0 1 2.5-2.5h.12a2.5 2.5 0 0 1 2.5 2.5z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m54.78 13.94v-13.19a.76.76 0 0 0 -.78-.75h-53.25a.76.76 0 0 0 -.75.75v19.82a.75.75 0 0 0 .75.75h1.71a3.89 3.89 0 0 0 7.39 0h.52a3.89 3.89 0 0 0 7.39 0h18.93a3.89 3.89 0 0 0 7.39 0h.52a3.89 3.89 0 0 0 7.39 0h2a.75.75 0 0 0 .75-.75v-4.73h-17.04v-1.9zm-4.42 7.38a2.4 2.4 0 0 1 -4.13 0zm-7.92 0a2.39 2.39 0 0 1 -4.12 0zm3.84-15.65a.5.5 0 0 1 .5-.5h4.12a.5.5 0 0 1 .5.5v5.47a.5.5 0 0 1 -.5.49h-4.12a.49.49 0 0 1 -.5-.49zm-40.13 16.83a2.4 2.4 0 0 1 -2.06-1.18h4.12a2.4 2.4 0 0 1 -2.06 1.18zm7.91 0a2.42 2.42 0 0 1 -2.06-1.18h4.13a2.43 2.43 0 0 1 -2.07 1.18zm6.69-6.66h-6a.58.58 0 0 1 -.18 0v2.12a1.5 1.5 0 0 1 -1.5 1.5h-5.53a1.5 1.5 0 0 1 -1.54-1.54v-2.08h-6v-1.9h6v-9.94a1.5 1.5 0 0 1 1.5-1.5h5.52a1.5 1.5 0 0 1 1.54 1.5v10a.58.58 0 0 1 .18 0h6zm1.59-4.21h-6a.5.5 0 0 1 -.5-.49v-5.47a.5.5 0 0 1 .5-.5h6zm13.74-6.46h8.75a.5.5 0 0 1 .5.5v5.47a.5.5 0 0 1 -.5.49h-8.75z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m23.74 5.5h10.95v10.95h-10.95z",
    fill: "#fff"
  }));
};

exports["default"] = _default;